import combineBatches from './combine-batches';
import createBatch from './create-batch';
import generateAdjustedEventTraits from './generate-adjusted-event-traits';
import generateModifiedEventTraits from './generate-modified-event-traits';
import generateInitialState from './generate-initial-state';
import getBatchValues from './get-batch-values';
import getTargetElementIds from './get-target-element-ids';
import getObjectDifference from './get-object-difference';
import { wrapSharedDataWithId, getSharedDataById } from './shared-data-utils';
import * as stageContracts from './stage-contracts';

export default {
  combineBatches,
  createBatch,
  generateAdjustedEventTraits,
  generateModifiedEventTraits,
  generateInitialState,
  getBatchValues,
  getTargetElementIds,
  getObjectDifference,
  wrapSharedDataWithId,
  getSharedDataById,
  stageContracts,
};
